import { Fragment } from "react";
import { cn } from "@/lib/utils";
import { CLIENT_STAGES } from "@shared/clientConstants";

/** Preparation → Closing, the part of an engagement a deal row cares about. */
const TRACK = CLIENT_STAGES.slice(CLIENT_STAGES.indexOf("Preparation"));

export function StageTrack({ stage }: { stage: string | null }) {
  const at = TRACK.indexOf((stage ?? "") as (typeof TRACK)[number]);
  if (at < 0) return <span className="text-[11px] text-muted-foreground">{stage ?? "No stage"}</span>;
  return (
    <span className="inline-flex items-center" role="img" aria-label={`Stage: ${stage}`} title={`Stage: ${stage}`}>
      {TRACK.map((s, i) => (
        <Fragment key={s}>
          {i > 0 && <span className={cn("w-3 h-px", i <= at ? "bg-sidebar dark:bg-primary" : "bg-border")} />}
          <span className={cn(
            "w-2 h-2 rounded-full border shrink-0",
            i < at && "bg-sidebar border-sidebar dark:bg-primary dark:border-primary",
            i === at && "border-sidebar dark:border-primary ring-2 ring-sidebar/20",
            i > at && "border-border bg-card",
          )} />
          {i === at && <span className="ml-1 mr-0.5 text-[11px] font-semibold whitespace-nowrap">{s}</span>}
        </Fragment>
      ))}
    </span>
  );
}
